module.exports = __webpack_public_path__ + "media/site_templates/www.cheaptaxaccountants.com.au/images/our_services_1-9e5d23b34d9d17c155a4c97b98c14277.jpg";